// extracted by mini-css-extract-plugin
export default {"loadMore":"components-Paging-loadMore-loadMore__loadMore--AJgcY"};